const scope = `businessOrganisation/`;
export const SET_LOADING_FLAG = `${scope}SET_LOADING_FLAG`;
export const ADD_ORGANISATION = `${scope}ADD_ORGANISATION`;
